<template>
	<div>
		<vxe-modal v-model="modal_model" :title="modal_title" :width="modal_width" :height="modal_height"
			@show="modal_onshow" show-footer @hide="modal_onhide" destroy-on-close :loading = "loading">
			<template #default>
				<vxe-grid ref="competitivegoodsList" v-if="list_gridOptions" v-bind="list_gridOptions"
					@toolbar-button-click="list_toolbarButtonClickEvent"></vxe-grid>	
				<shop :shop="shop" :grabcode="grabcode" ref="shopIndex" @submit="shopSubmit" />
			</template>
			<template #footer>
				<vxe-button status="" content="返回" @click="modal_cancel"></vxe-button>
			</template>
		</vxe-modal>
	</div>
</template>
<style scoped>

</style>
<script>
	import listMixins from '@_system/components/base/mixins/list/list.js'
	import modalMixins from '@_system/components/base/mixins/modal/modal.js'
	import shop from './shop.vue'
	export default {
		mixins: [listMixins, modalMixins],
		props: {
			data: {
				default: () => {
					return []
				}
			},
		},
		data() {
			return {
				loading:false,
				shop:[],
				grabcode:"",
				modal_model: false,
				modal_title: '系统任务',
				modal_width: 1000,
				modal_height: 600,
				currentrow: {},
				list_formConfig: [{
					field: 'a',
					title: 'A',
					itemRender: {
						name: '$input'
					}
				}],
				list_columns: [{
						field: 'grabcode',
						title: '任务编码',
					},
					{
						field: 'count',
						title: '总量',
					},
					{
						field: 'process',
						title: '进度(%)',
						formatter: ''
					},
					{
						title: '操作',
						fixed: "right",
						align: 'center',
						width: 65,
						slots: {
							default: ({
								row
							}) => {
								return [ <el-button type = "text" size = "mini" onClick = {() => {this.export(row)}} >导出</el-button>]
							}
						}
					}
				]
				// list_footerField:[
				// 	{field:'needamount',toFixed:2}
				// ]
			}
		},
		watch: {

		},
		computed: {
			device() {
				return window.systemMethods.device()
			}
		},
		created() {

		},
		mounted() {

		},
		methods: {
			add(){
				this.loading = true
				this.$api.competitivegoodstask.addtask().then(() => {
					this.loading = false
					this.$refs.competitivegoodsList.commitProxy('query')	
				},()=>{
					this.loading = false
				})
			},
			export(row){
				this.grabcode = row.grabcode
				this.loading = true
				this.$api.competitivegoodstask.listsystemtaskshop({
					grabcode:this.grabcode
				}).then((res) => {
					this.loading = false
					this.shop = res
					this.$nextTick(()=>{
						this.$refs.shopIndex.modal_show()
					})
				},()=>{
					this.loading = false
				})
				
			},
			edit(row) {
				this.currentrow = row
				this.$nextTick(() => {
					this.$refs.competitivegoodsForm.modal_show()
				})
			},
			list_beforeCreateGrid(gridOptions) {
				gridOptions.formConfig = false
				gridOptions.pagerConfig.enabled = true
				gridOptions.toolbarConfig.buttons = [
					{
					name: '新增任务',
					status: 'primary',
					code: 'add'
				},
				]
			},
			list() {
				return new Promise((resolve) => {
					this.$api.competitivegoodstask.listsystemtask().then((res) => {
						resolve(res)
					})
				})
			},
			submitSuccess() {
				this.$refs.competitivegoodsList.commitProxy('query')
			},
			submit() {
				//this.init()
			},
			reset() {
				//this.init()
			},
			shopSubmit(e){
				console.log(e,this.data)
			}
		},
		components: {
			shop
		}
	}
</script>